import React from 'react';
import { techStack } from '../data/mock';
import { Card } from './ui/card';
import { Badge } from './ui/badge';

const TechStack = () => {
  const categories = [
    { title: 'Frontend', items: techStack.frontend },
    { title: 'Backend', items: techStack.backend },
    { title: 'Mobile & Cloud', items: techStack.mobile },
    { title: 'Databases & AI', items: techStack.database }
  ];

  return (
    <section className="py-20 px-6 bg-muted/30">
      <div className="container mx-auto max-w-6xl">
        <div className="space-y-4 mb-12">
          <h2 className="text-sm font-mono text-cyan-500 uppercase tracking-wider">
            What I work with
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold">Tech Stack</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {categories.map((category, index) => (
            <Card key={index} className="p-6 hover:shadow-lg transition-shadow">
              <h4 className="text-xl font-bold mb-4">{category.title}</h4>
              <div className="flex flex-wrap gap-2">
                {category.items.map((tech, techIndex) => (
                  <Badge
                    key={techIndex}
                    variant="secondary"
                    className="px-3 py-1 text-sm font-mono"
                  >
                    {tech}
                  </Badge>
                ))}
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
